import React, { useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import moment from 'moment';

import useTingStore from '../../stores/tingStore';

export default function TingEssentialDetails() {
    const tingDoc = useTingStore(state => state.tingDoc);
    const setTingDoc = useTingStore(state => state.setTingDoc);
    const dateInputRef = useRef(null);

    const handleChange = (event) => {
        setTingDoc({
            ...tingDoc,
            [event.target.id]: event.target.value
        });
    };

    const handleDateChange = (event) => {
        const date = moment(event.target.value).toDate();
        setTingDoc({
            ...tingDoc,
            tingTime: date
        });
    };

    const formattedTime = tingDoc?.tingTime
        ? moment(tingDoc.tingTime.seconds ? tingDoc.tingTime.seconds * 1000 : tingDoc.tingTime).format('YYYY-MM-DDTHH:mm')
        : '';

    useEffect(() => {
        const dateInput = dateInputRef.current;
        if (!dateInput || typeof dateInput.showPicker !== 'function') return undefined;

        const openPicker = () => {
            dateInput.showPicker();
        };

        dateInput.addEventListener('click', openPicker);

        return () => {
            dateInput.removeEventListener('click', openPicker);
        };
    }, []);

    return (
        <Box component="form" className="ting-editor__form">
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        id="tingTime"
                        label="Time of Sighting"
                        type="datetime-local"
                        inputRef={dateInputRef}
                        value={formattedTime}
                        onChange={handleDateChange}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        id="park"
                        label="Park"
                        value={tingDoc?.park ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <TextField
                        id="number"
                        label="How many"
                        value={tingDoc?.number ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        id="animal"
                        label="Animal"
                        value={tingDoc?.animal ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        id="action"
                        label="Action"
                        value={tingDoc?.action ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        id="extraAnimal"
                        label="Extra animal"
                        value={tingDoc?.extraAnimal ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        id="roadname"
                        label="Road name"
                        value={tingDoc?.roadname ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={8}>
                    <TextField
                        id="locationDescription"
                        label="Location description"
                        value={tingDoc?.locationDescription ?? ''}
                        onChange={handleChange}
                        rows={2}
                        multiline
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <TextField
                        id="visibility"
                        label="Visibility"
                        value={tingDoc?.visibility ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <TextField
                        id="traffic"
                        label="Cars"
                        value={tingDoc?.traffic ?? ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={8}>
                    <TextField
                        id="tingDescription"
                        label="Ting description"
                        value={tingDoc?.tingDescription ?? ''}
                        onChange={handleChange}
                        rows={3}
                        multiline
                        size="small"
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
